import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { Dict } from '@chakra-ui/utils';
import { chakraUiTheme } from '../index';

export type DesignSystemThemes = 'chakraUiTheme' | 'wcn' | 'k12';

export function useTheme(key: DesignSystemThemes = 'chakraUiTheme') {
  const themeModules: Record<DesignSystemThemes, any> = useMemo(
    () => ({
      chakraUiTheme: () => ({ chakraUiTheme }),
      wcn: () => import('../wcn'),
      k12: () => import('../k12'),
    }),
    []
  );
  /**
   * State
   */
  const [activeThemeDict, setActiveThemeDict] = useState<Dict>(chakraUiTheme);
  const [activeThemeKey, setActiveThemeKey] = useState<DesignSystemThemes>('chakraUiTheme');
  const [themeKeys] = useState<DesignSystemThemes[]>(Object.keys(themeModules) as DesignSystemThemes[]).sort();

  /**
   * Methods
   */
  const getThemeDict = useCallback(async (key: DesignSystemThemes) => {
    const themeModule = await themeModules[key]();
    return themeModule[key];
  }, []);

  const setTheme = useCallback(async (key: DesignSystemThemes) => {
    try {
      const dict = await getThemeDict(key);
      setActiveThemeDict(dict);
      setActiveThemeKey(key);
    } catch (e) {
      // Fallback to default
      setActiveThemeDict(themeModules.chakraUiTheme);
      setActiveThemeKey('chakraUiTheme');
    }
  }, []);

  useEffect(() => {
    setTheme(key);
  }, [setTheme]);

  return {
    themeKeys,
    activeThemeKey,
    activeThemeDict,
    setActiveThemeDict: React.useCallback((key: DesignSystemThemes) => {
      setTheme(key);
    }, []),
  };
}
